import React from 'react'
import { useDispatch } from 'react-redux'
import GeneralInfoWithThumbnail from '../../../components/GeneralInfoWithThumbnail'
import openChat from '../openChat'
import getMugshotSrc from '../../../utils/getMugshotSrc'
import AmountOfNotifications from './AmountOfNotifications'
import { ChatWithAttendee } from '../types'
import formatJobInfo from '../../../utils/formatJobInfo'
import useSlug from '../../../hooks/useSlug'

interface ChatListItemProps {
    chat: ChatWithAttendee
    active: boolean
}

const ChatListItem = ({ chat, active = false }: ChatListItemProps) => {
    const eventSlug = useSlug('eventSlug')
    const dispatch = useDispatch()
    const onClick = active
        ? () => null
        : () => dispatch(openChat(eventSlug, chat.user_id))
    return (
        <GeneralInfoWithThumbnail
            key={chat.user_id}
            onClick={onClick}
            active={active}
            image={getMugshotSrc(chat.user)}
            name={`${chat.user.first_name} ${chat.user.last_name}`}
            description={formatJobInfo(chat.user.jobtitle, chat.user.company)}
            badge={chat.user.is_online ? 'success' : 'danger'}
        >
            <AmountOfNotifications amount={chat.unread} onClick={onClick} />
        </GeneralInfoWithThumbnail>
    )
}

export default ChatListItem
